import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi } from "./useAdminApi";
import { PanelHeader } from "./LeadsPanel";

export default function UsersPanel() {
  const api = useAdminApi();
  const [data, setData] = useState(null);
  const load = () => api.get("/users").then(setData);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const change = async (u, role) => {
    try {
      await api.patch(`/users/${u.user_id}/role`, { role });
      toast.success("Role updated");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Not allowed");
    }
    load();
  };

  return (
    <div data-testid="users-panel">
      <PanelHeader title="Users" sub="Only admins can open this dashboard. Anyone else who signs up has no access until you make them admin." />
      {!data ? <p className="text-slate-500">Loading…</p> : (
        <div className="space-y-3">
          {data.users.map((u) => (
            <div key={u.user_id} className="flex items-center justify-between gap-4 rounded-2xl bg-[#131B21] border border-white/5 p-4" data-testid={`user-row-${u.user_id}`}>
              <div className="min-w-0"><p className="font-semibold truncate">{u.email || u.user_id}</p><p className="text-xs text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString() : ""}</p></div>
              <select value={u.role} onChange={(e) => change(u, e.target.value)} className="bg-[#0B0F12] border border-white/10 rounded-lg px-3 py-2 text-sm" data-testid={`user-role-select-${u.user_id}`}>
                {data.roles.map((r) => <option key={r} value={r}>{r === "member" ? "no access" : r}</option>)}
              </select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
